import "./Services.css"
import img1 from "../../images/img1.jpg"
import img2 from "../../images/img2.jpg"
import img3 from "../../images/img3.jpg"
import img4 from "../../images/img4.jpg"
import img5 from "../../images/img5.jpg"
import img6 from "../../images/img6.jpg"
import img7 from "../../images/img7.jpg"
import img8 from "../../images/img8.jpg"
import img9 from "../../images/img9.jpg"
import img10 from "../../images/img10.jpg"
import img11 from "../../images/img11.jpg"
import img12 from "../../images/img12.jpg"
import img13 from "../../images/img13.jpg"
import img14 from "../../images/img14.jpg"
import AOS from "aos"
import "aos/dist/aos.css";
import { useEffect } from "react";

export default function Services() {
    useEffect(() => {
        AOS.init({ duration: 3000 })
    }, [])
    return (
        <div data-aos="fade-up" className="ServicesMainHome">
            <p className="servicesHead">SERVICES OFFERED</p>
            <div className="allCards">
                <div className="card">
                    <div className="serviceNameHead">
                        <h1 className="serviceName">Civil Court and Property Disputes</h1>
                    </div>
                    <div className="AllRightContent">
                        <img src={img1} className="eachImg" />
                        <div className="rightContent">
                            <p className="desc">Trust our legal expertise to resolve your civil court cases and property disputes effectively, protecting your rights and interests throughout the process.</p>
                        </div>
                    </div>
                </div>


                <div className="card" >
                    <div className="serviceNameHead">  <h1 className="serviceName">Verification of Property Documents and Legal Advice</h1></div>

                    
                        <div className="AllRightContent">
                            <img src={img2} className="eachImg" />
                            <div className="rightContent">
                            <p className="desc">Ensure a secure property purchase with our thorough verification of documents, providing reliable information and expert legal advice to make informed decisions.</p>
                        </div>
                    </div>
                </div>
                <div className="card" >
                    <div className="serviceNameHead">   <h1 className="serviceName">Drafting of Rental, Property, and Business Agreements</h1></div>

                  
                        <div className="AllRightContent">
                            <img src={img3} className="eachImg" />
                            <div className="rightContent">
                            <p className="desc"> Safeguard your interests in rental, property, and business transactions with our meticulous drafting of agreements, ensuring legal soundness and protection.</p>
                        </div>
                    </div>
                </div>
                <div className="card" data-aos="fade-up">
                    <div className="serviceNameHead"> <h1 className="serviceName">Muslim Personal Law and Succession Cases</h1></div>

            
                        <div className="AllRightContent">
                            <img src={img4} className="eachImg" />
                            <div className="rightContent">
                            <p className="desc">Receive specialized legal support in matters of Muslim personal law and succession, addressing inheritance, estate planning, and family property disputes.</p>
                        </div>
                    </div>
                </div>
                <div className="card" data-aos="fade-up">
                    <div className="serviceNameHead">  <h1 className="serviceName">Legal Heir Certificate</h1></div>

                 
                        <div className="AllRightContent">
                            <img src={img14} className="eachImg" />
                            <div className="rightContent">
                            <p className="desc">Help clients obtain Legal Heir Certificates to facilitate the claiming and distribution of properties and assets left by the deceased. This ensures a seamless transition of ownership while safeguarding the rights of the legal heirs.</p>
                        </div>
                    </div>
                </div>
                <div className="card" data-aos="fade-up">
                    <div className="serviceNameHead"> <h1 className="serviceName">Family Law, Divorce, Maintenance, and Guardianship Cases</h1></div>

               
                        <div className="AllRightContent">
                            <img src={img5} className="eachImg" />
                            <div className="rightContent">
                            <p className="desc">Navigate family-related legal challenges with compassion and expertise, seeking resolutions for divorce, maintenance, guardianship, and the well-being of all involved.</p>
                        </div>
                    </div>
                </div>
                <div className="card" data-aos="fade-up">
                    <div className="serviceNameHead"> <h1 className="serviceName">Writ Petitions, Appeals, and Revisions in the High Court</h1></div>

            
                        <div className="AllRightContent">
                            <img src={img6} className="eachImg" />
                            <div className="rightContent">
                            <p className="desc">Rely on our skilled team to handle writ petitions, appeals, and revisions in the High Court, presenting strong arguments to pursue justice and favorable outcomes.</p>
                        </div>
                    </div>
                </div>
                <div className="card" data-aos="fade-up">
                    <div className="serviceNameHead"><h1 className="serviceName">Quash Petitions against Police FIRs and Charge Sheets</h1></div>

     
                        <div className="AllRightContent">
                            <img src={img7} className="eachImg" />
                            <div className="rightContent">
                            <p className="desc"> Challenge the validity of police FIRs and charge sheets with our experienced legal representation, aiming to protect your reputation and rights.</p>
                        </div>
                    </div>
                </div>
                <div className="card" data-aos="fade-up">
                    <div className="serviceNameHead">  <h1 className="serviceName">Criminal Cases and Bail Matters</h1></div>


                        <div className="AllRightContent">
                            <img src={img8} className="eachImg" />
                            <div className="rightContent">
                            <p className="desc">Trust our dedicated criminal defense attorneys to provide effective representation in criminal cases and bail matters, ensuring fair treatment and seeking the best possible outcomes for you.</p>
                        </div>
                    </div>
                </div>
                <div className="card" data-aos="fade-up">
                    <div className="serviceNameHead">       <h1 className="serviceName">Consumer Forum Cases</h1></div>

               
                        <div className="AllRightContent">
                            <img src={img9} className="eachImg" />
                            <div className="rightContent">
                            <p className="desc">Seek justice and compensation with our comprehensive assistance in consumer forum cases, guiding you through the complaint process and advocating for your consumer rights.</p>
                        </div>
                    </div>
                </div>
                <div className="card" data-aos="fade-up">
                    <div className="serviceNameHead">   <h1 className="serviceName">Service Matters, Pay, Promotion, Disciplinary Proceedings</h1></div>

      
                        <div className="AllRightContent">
                            <img src={img10} className="eachImg" />
                            <div className="rightContent">
                            <p className="desc">Resolve service-related issues, including pay, promotion, and disciplinary proceedings, with our knowledgeable team providing guidance and representation to protect your rights.</p>
                        </div>
                    </div>
                </div>
                <div className="card" data-aos="fade-up">
                    <div className="serviceNameHead">  <h1 className="serviceName">Departmental Enquiries and Penalties</h1></div>

             
                        <div className="AllRightContent">
                            <img src={img11} className="eachImg" />
                            <div className="rightContent">
                            <p className="desc">Receive comprehensive support in departmental enquiries and penalties, ensuring fair proceedings and protecting your rights throughout the process.</p>
                        </div>
                    </div>
                </div>
                <div className="card" data-aos="fade-up">
                    <div className="serviceNameHead">    <h1 className="serviceName">Industrial Disputes Involving Workman and Management</h1></div>

  
                        <div className="AllRightContent">
                            <img src={img12} className="eachImg" />
                            <div className="rightContent">
                            <p className="desc">Resolve conflicts between workmen and management in industrial settings with our expertise in strategic advice, mediation, and strong representation.</p>
                        </div>
                    </div>
                </div>
                <div className="card" data-aos="fade-up">
                    <div className="serviceNameHead">   <h1 className="serviceName">Disputes in the Matter of Admission in Private Educational Institutions</h1></div>

    
                        <div className="AllRightContent">
                            <img src={img13} className="eachImg" />
                            <div className="rightContent">
                            <p className="desc">Obtain assistance in resolving disputes concerning admission, fees, and documents retention in private educational institutions, ensuring fair treatment and protecting your rights as a student or parent.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}